// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingPage_loadingContainer__KtaXs","loadingVideo":"LoadingPage_loadingVideo__J10w+"};